import { format } from "date-fns";
import React from "react";
import DownloadIcon from "assets/images/download-icon.svg";
import "./styles.scss";

interface Props {
  data: any[];
  onDownload?: (val: any) => void;
}

const OrderTableMobile = ({ data, onDownload }: Props) => {
  return (
    <table className="orders-table-mobile">
      <thead>
        <th>
          <div className="headtext-otr">
            <p className="head-text">הזמנה</p>
          </div>
        </th>
        <th>
          <div className="headtext-otr">
            <p className="head-text">תאריך</p>
          </div>
        </th>
        <th>
          <div className="headtext-otr">
            <p className="head-text">סכום</p>
          </div>
        </th>
        <th>
          <div className="headtext-otr">
            <p className="head-text">קבלה</p>
          </div>
        </th>
      </thead>
      <tbody>
        {data?.map((val: any, index) => {
          return (
            <tr key={`${index}${val?.orderId}`} className="order-table-item-product-wrapper">
              <td>
                <div className="bodytext-otr">
                  <p className="order-table-text">{val?.orderId}</p>
                </div>
              </td>
              <td>
                <div className="bodytext-otr">
                  <p className="order-table-text">
                    {format(new Date(val?.orderDate), "dd/LL/yyyy")}
                  </p>
                </div>
              </td>
              <td>
                <div className="bodytext-otr">
                  <p className="order-table-title">{val?.productTitle}</p>

                  <p className="order-table-text">₪{val?.sum}</p>
                </div>
              </td>
              <td onClick={() => onDownload && onDownload(val)}>
                <span className="download-icon-otr" style={{ cursor: "pointer" }}>
                  <img className="download-icon" src={DownloadIcon} alt="icon" />
                </span>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default OrderTableMobile;
